import i18n from 'i18next';
import XHR from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';
import locales from './locales/index';

// var userLanguage = (localStorage.getItem("i18nextLng") && localStorage.getItem("i18nextLng").substr(0,2)) || null
// var browserLanguage = navigator.language || navigator.userLanguage;

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init({
    fallbackLng: 'tr',
    // debug: true,
    interpolation: {
      escapeValue: false, 
    },
    // lng: userLanguage || browserLanguage ,
    lng: "tr",
    react: {
      wait: false,
      bindI18n: 'languageChanged loaded',
      bindStore: 'added removed',
      nsMode: 'default'
    },
    resources: locales
  });


export default i18n;


// WEBPACK FOOTER //
// ./src/plugins/i18n/i18n.js